<template>
  <!-- <b-card-code :title="$t('patient.mobile')"> -->
  <div>
    <b-modal
      v-model="spouseRemoveConfirmation"
      :cancel-title="$t('general.no')"
      :ok-title="$t('general.yes')"
      centered
      size="sm"
      @cancel="spouseRemoveConfirmation = false"
      @ok="spouseDeletionConfirmed"
    >
      <p>
        {{
          $t("toastification.areYouSureOfDeletion", {
            item: spouseToDelete
              ? spouseToDelete.spouseId.firstName +
                " " +
                spouseToDelete.spouseId.lastName
              : "",
          })
        }}
      </p>
    </b-modal>
    <b-form
      ref="spouseForm"
      :style="{ height: trHeight }"
      class="repeater-form mt-0"
      @submit.prevent="repeateAgain"
    >
      <template v-for="(spouse, index) in spouses">
        <b-row
          v-if="spouse.spouseId._id !== 0 || index === 0"
          :key="index"
          ref="spouseRow"
          class="mt-2"
        >
          <b-col md="12">
            <b-row
              ><b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  v-if="!isSpouseForeigner[index]"
                  valid-feedback=""
                  :disabled="!isMarried"
                  label-for="admission-spouseNationalCode"
                  :label="$t('user.spouseNationalCode')"
                  :state="
                    isMarried &&
                    v.spouses.$each.$iter[index].spouseId.nationalCode.$dirty
                      ? !v.spouses.$each.$iter[index].spouseId.nationalCode
                          .$invalid === false
                        ? false
                        : null
                      : null
                  "
                  :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].spouseId.nationalCode
                        .multiRequired,
                  }"
                >
                  <div class="form-label-group">
                    <b-form-input
                      :disabled="!isMarried"
                      v-model="spouse.spouseId.nationalCode"
                      id="admission-spouseNationalCode"
                      dir="ltr"
                      type="number"
                      oninput="if (this.value.length > 10) this.value = this.value.slice(0, 10);"
                      :state="
                        isMarried &&
                        v.spouses.$each.$iter[index].spouseId.nationalCode
                          .$dirty
                          ? !v.spouses.$each.$iter[index].spouseId.nationalCode
                              .$invalid === false
                            ? false
                            : null
                          : null
                      "
                      @input="
                        (val) => {
                          searchNationalCode(val);
                        }
                      "
                    />
                    <b-form-invalid-feedback>
                      {{
                        invalidFeedbackSpouseNationalCode(index)
                          ? $t(
                              `validation.${invalidFeedbackSpouseNationalCode(
                                index
                              )}`,
                              {
                                field: $t("user.spouseNationalCode"),
                              }
                            )
                          : ""
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
                <b-form-group
                  v-else
                  :label="$t('user.spouseIdentityCode')"
                  label-for="admission-spouseIdentityCode"
                >
                  <b-form-input
                    :disabled="!isMarried"
                    v-model="spouse.spouseId.identityCode"
                    id="admission-spouseIdentityCode"
                  />
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  label-for="admission-spouseFirstName"
                  :label="$t('user.spouseFirstName')"
                  :state="
                    v.spouses.$each.$iter[index].spouseId.firstName.$dirty
                      ? !v.spouses.$each.$iter[index].spouseId.firstName
                          .$invalid === false
                        ? false
                        : null
                      : null
                  "
                  :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].spouseId.firstName
                        .multiRequired,
                  }"
                >
                  <div class="form-label-group">
                    <b-form-input
                      trim
                      :state="
                        v.spouses.$each.$iter[index].spouseId.firstName.$dirty
                          ? !v.spouses.$each.$iter[index].spouseId.firstName
                              .$invalid === false
                            ? false
                            : null
                          : null
                      "
                      :disabled="!isMarried"
                      v-model="spouse.spouseId.firstName"
                      id="admission-spouseFirstName"
                    />
                    <b-form-invalid-feedback>
                      {{
                        invalidFeedbackSpouseFirstName(index)
                          ? $t(
                              `validation.${invalidFeedbackSpouseFirstName(
                                index
                              )}`,
                              {
                                field: $t("user.spouseFirstName"),
                              }
                            )
                          : ""
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  :state="
                    isMarried &&
                    v.spouses.$each.$iter[index].spouseId.lastName.$dirty
                      ? !v.spouses.$each.$iter[index].spouseId.lastName
                          .$invalid === false
                        ? false
                        : null
                      : null
                  "
                  label-for="admission-spouseLastName"
                  :label="$t('user.spouseLastName')"
                  :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].spouseId.lastName
                        .multiRequired,
                  }"
                >
                  <div class="form-label-group">
                    <b-form-input
                      :state="
                        isMarried &&
                        v.spouses.$each.$iter[index].spouseId.lastName.$dirty
                          ? !v.spouses.$each.$iter[index].spouseId.lastName
                              .$invalid === false
                            ? false
                            : null
                          : null
                      "
                      :disabled="!isMarried"
                      v-model="spouse.spouseId.lastName"
                      id="admission-spouseLastName"
                    />
                    <b-form-invalid-feedback>
                      {{
                        invalidFeedbackSpouseLastName(index)
                          ? $t(
                              `validation.${invalidFeedbackSpouseLastName(
                                index
                              )}`,
                              {
                                field: $t("user.spouseLastName"),
                              }
                            )
                          : ""
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  :state="
                    isMarried &&
                    v.spouses.$each.$iter[index].spouseId.fatherName.$dirty
                      ? !v.spouses.$each.$iter[index].spouseId.fatherName
                          .$invalid === false
                        ? false
                        : null
                      : null
                  "
                  :label-for="`admission-spouse-fatherName${index}`"
                  :label="$t('user.fathersName')"
                  :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].spouseId.fatherName
                        .multiRequired,
                  }"
                >
                  <div class="form-label-group">
                    <b-form-input
                      :state="
                        isMarried &&
                        v.spouses.$each.$iter[index].spouseId.fatherName.$dirty
                          ? !v.spouses.$each.$iter[index].spouseId.fatherName
                              .$invalid === false
                            ? false
                            : null
                          : null
                      "
                      :disabled="!isMarried"
                      v-model="spouse.spouseId.fatherName"
                      :id="`admission-spouse-fatherName${index}`"
                    />
                    <b-form-invalid-feedback>
                      {{
                        invalidFeedbackSpouseFatherName(index)
                          ? $t(
                              `validation.${invalidFeedbackSpouseFatherName(
                                index
                              )}`,
                              {
                                field: $t("user.fathersName"),
                              }
                            )
                          : ""
                      }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                    :state="
                    isMarried &&
                    v.spouses.$each.$iter[index].spouseId.countryId.$dirty
                      ? !v.spouses.$each.$iter[index].spouseId.countryId
                          .$invalid === false
                        ? false
                        : null
                      : null
                  "
                    :label="$t('user.nationality')"
                    :label-for="`admission-spouse-countryId${index}`"
                    :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].spouseId.countryId
                        .multiRequired,
                  }"
                >
                  <my-v-select
                      :key="spouse.spouseId.countryId"
                      :id="`admission-spouse-countryId${index}`"
                      :disabled="!isMarried"
                      v-if="countries"
                      :translate="false"
                      v-model="spouse.spouseId.countryId"
                      :concat-label="['title.fa']"
                      :options="countries.length ? countries : []"
                      :multiple="false"
                      :searchable="true"
                      :filterable="true"
                      @input="spouseCountrySelected(index)"
                  />
                </b-form-group>
                <b-form-invalid-feedback>
                  {{
                    invalidFeedbackSpouseDateOfCountry(index)
                        ? $t(
                            `validation.${invalidFeedbackSpouseDateOfCountry(
                                index
                            )}`,
                            {
                              field: $t("user.nationality"),
                            }
                        )
                        : ""
                  }}
                </b-form-invalid-feedback>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  :invalid-feedback="
                    invalidFeedbackSpouseDateOfBirth(index)
                      ? $t(
                          `validation.${invalidFeedbackSpouseDateOfBirth(
                            index
                          )}`,
                          {
                            field: $t('user.dateOfBirth'),
                          }
                        )
                      : ''
                  "
                  :state="
                    isMarried &&
                    v.spouses.$each.$iter[index].spouseId.dateOfBirth.$dirty
                      ? !v.spouses.$each.$iter[index].spouseId.dateOfBirth
                          .$invalid === false
                        ? false
                        : null
                      : null
                  "
                  :label-for="`admission-spouse-dateOfBirth${index}`"
                  :label="isSpouseForeigner[index] ? $t('user.gregorianDateOfBirth') :  $t('user.solarDateOfBirth')"

                  :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].spouseId.dateOfBirth
                        .multiRequired,
                  }"
                >
                  <my-cleave-date
                    :disabled="!isMarried"
                    :key="spouse.spouseId.dateOfBirth"
                    @updateDate="(val)=>{$set(spouse.spouseId, 'dateOfBirth', val)}"
                    :value="spouse.spouseId.dateOfBirth"
                    :isForeigner="isSpouseForeigner[index]"
                    @error="(val) => $emit('spouseDateOfBirthNotValid', val)"
                  >
                  </my-cleave-date>
                  <!-- <my-ab-date-picker
                    :mode="'single'"
                    :type="'date'"
                    :locale="'fa,en'"
                    click-on="all"
                    clearable
                    :show="false"
                    :auto-submit="true"
                    :column="1"
                    v-model="spouse.spouseId.dateOfBirth"
                    :class="{ disabled: !isMarried }"
                    class="my-ab-date-picker"
                    :id="`admission-spouse-dateOfBirth${index}`"
                    :key="spouse.spouseId.dateOfBirth"
                    
                  >
                  </my-ab-date-picker> -->

                  <!-- <div class="form-label-group">

                  <b-form-input
                    :state="
                      isMarried &&
                      v.spouses.$each.$iter[index].spouseId.dateOfBirth.$dirty
                        ? !v.spouses.$each.$iter[index].spouseId.dateOfBirth
                            .$invalid
                        : null
                    "
                    :value="dateToPersian(spouseDateOfBirth[index])"
                    :disabled="!isMarried"
                    dir="ltr"
                    :id="`admission-spouse-dateOfBirth${index}`"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    {{
                      invalidFeedbackSpouseDateOfBirth(index)
                        ? $t(
                            `validation.${invalidFeedbackSpouseDateOfBirth(
                              index
                            )}`,
                            {
                              field: $t("user.dateOfBirth"),
                            }
                          )
                        : ""
                    }}
                  </b-form-invalid-feedback>
                  <date-picker
                    format="YYYY/MM/DD"
                    locale="fa,en"
                    @input="spouse.spouseId.dateOfBirth = toIsoDate($event)"
                    :locale-config="{
                      fa: {
                        displayFormat: 'jYYYY/jMM/jDD',
                        lang: { label: 'شمسی' },
                      },
                      en: {
                        displayFormat: 'YYYY/MM/DD',
                        lang: { label: 'میلادی' },
                      },
                    }"
                    v-model="spouseDateOfBirth[index]"
                    :element="`admission-spouse-dateOfBirth${index}`"
                  />
                </div> -->
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  :state="
                    isMarried &&
                    v.spouses.$each.$iter[index].relationshipId.dateOfMarriage
                      .$dirty
                      ? !v.spouses.$each.$iter[index].relationshipId
                          .dateOfMarriage.$invalid === false
                        ? false
                        : null
                      : null
                  "
                  :label-for="`admission-spouse-dateOfMarriage${index}`"
                  :label="$t('user.dateOfMarriage')"
                  :disabled="!isMarried"
                  :invalid-feedback="
                    invalidFeedbackSpouseDateOfMarriage(index)
                      ? $t(
                          `validation.${invalidFeedbackSpouseDateOfMarriage(
                            index
                          )}`,
                          {
                            field: $t('user.dateOfMarriage'),
                          }
                        )
                      : ''
                  "
                  :class="{
                    'required-group':
                      !v.spouses.$each.$iter[index].relationshipId
                        .dateOfMarriage.multiRequired,
                  }"
                >
                  <!--                <date-picker-->
                  <!--                  mode="single"-->
                  <!--                  type="date"-->
                  <!--                  :column="1"-->
                  <!--                  locale="fa,en"-->
                  <!--                  :locale-config="{-->
                  <!--                    fa: {-->
                  <!--                      inputFormat: 'jYYYY/jMM/jDD',-->
                  <!--                    },-->
                  <!--                    en: {-->
                  <!--                      format: 'YYYY-MM-DD',-->
                  <!--                    },-->
                  <!--                  }"-->
                  <!--                  :click-on="isMarried ? 'all' : 'none'"-->
                  <!--                  format="YYYY-MM-DD HH:mm:ss.sss"-->
                  <!--                  :to="persianToday"-->
                  <!--                  clearable-->
                  <!--                  :show="false"-->
                  <!--                  :auto-submit="false"-->
                  <!--                  v-model="spouse.relationshipId.dateOfMarriage"-->
                  <!--                >-->
                  <!--                  <template #clear>-->
                  <!--                    <b-icon-->
                  <!--                      v-if="spouse.relationshipId.dateOfMarriage"-->
                  <!--                      scale="2"-->
                  <!--                      aria-hidden="true"-->
                  <!--                      icon="x"-->
                  <!--                    ></b-icon>-->
                  <!--                  </template>-->
                  <!--                </date-picker>-->
                  <my-cleave-date
                    :disabled="!isMarried"
                    :isForeigner="isSpouseForeigner[index]"
                    @updateDate="(val)=>{$set(spouse.relationshipId, 'dateOfMarriage', val)}"
                    :value="spouse.relationshipId.dateOfMarriage"
                    @error="(val) => $emit('dateOfMarriageNotValid', val)"
                  >
                  </my-cleave-date>

                  <!-- <my-ab-date-picker
                    :mode="'single'"
                    :type="'date'"
                    :locale="'fa,en'"
                    click-on="all"
                    clearable
                    :to="'1499'"
                    :from="dateToPersian(spouse.spouseId.dateOfBirth)"
                    :show="false"
                    :auto-submit="true"
                    :column="1"
                    :key="spouse.relationshipId.dateOfMarriage"
                    v-model="spouse.relationshipId.dateOfMarriage"
                    :disabled="!spouse"
                    :class="{ disabled: !isMarried }"
                    class="my-ab-date-picker"
                    
                  >
                  </my-ab-date-picker> -->

                  <!-- <div class="form-label-group">
                  <b-form-input
                    :state="
                      isMarried &&
                      v.spouses.$each.$iter[index].relationshipId.dateOfMarriage
                        .$dirty
                        ? !v.spouses.$each.$iter[index].relationshipId
                            .dateOfMarriage.$invalid
                        : null
                    "
                    :disabled="!isMarried"
                    dir="ltr"
                    :value="dateToPersian(spouseDateOfMarriage[index])"
                    :id="`admission-spouse-dateOfMarriage${index}`"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    {{
                      invalidFeedbackSpouseDateOfMarriage(index)
                        ? $t(
                            `validation.${invalidFeedbackSpouseDateOfMarriage(
                              index
                            )}`,
                            {
                              field: $t("user.dateOfMarriage"),
                            }
                          )
                        : ""
                    }}
                  </b-form-invalid-feedback>
                  <date-picker
                  format="YYYY/MM/DD"
                    locale="fa,en"
                    @input="
                      spouse.relationshipId.dateOfMarriage = toIsoDate($event)
                    "
                    :locale-config="{
                      fa: {
                        displayFormat: 'jYYYY/jMM/jDD',
                        lang: { label: 'شمسی' },
                      },
                      en: {
                        displayFormat: 'YYYY/MM/DD',
                        lang: { label: 'میلادی' },
                      },
                    }"
                    v-model="spouseDateOfMarriage[index]"
                    :element="`admission-spouse-dateOfMarriage${index}`"
                  />
                </div> -->
                </b-form-group>
              </b-col>

              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  :disabled="!isMarried"
                  label-for="admission-spouseJob"
                  :label="$t('user.spouseJob')"
                >
                  <div class="form-label-group">
                    <b-form-input
                      :disabled="!isMarried"
                      v-model="spouse.spouseId.job"
                      id="admission-spouseJob"
                      dir="rtl"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col xl="2" lg="3" md="4" sm="6">
                <b-form-group
                  label-for="admission-spouseEducationalDegree"
                  :label="$t('user.spouseEducationalDegree')"
                >
                  <div class="form-label-group">
                    <my-v-select
                      :key="spouse.spouseId.educationalDegree"
                      id="admission-spouseEducationalDegree"
                      :disabled="!isMarried"
                      v-if="educationalDegreeTypes"
                      :translate="false"
                      v-model="spouse.spouseId.educationalDegree"
                      :concat-label="['text']"
                      :reduce-field="['value']"
                      :options="
                        educationalDegreeTypes.length
                          ? educationalDegreeTypes
                          : []
                      "
                      :multiple="false"
                      :searchable="true"
                      :filterable="true"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <!-- Remove and Add Button -->
              <b-col>
                <div class="action-buttons has-margin sm">
                  <b-button
                    v-if="
                      $route.name == 'editUser' || $route.name == 'editPatient'
                    "
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="white"
                    @click="removeItem(index)"
                  >
                    <b-icon icon="x-circle" variant="danger" scale="2"></b-icon>
                  </b-button>
                  <b-button
                    v-if="
                      $route.name == 'editUser' || $route.name == 'editPatient'
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="white"
                    @click="repeateAgain"
                  >
                    <b-icon
                      icon="plus-circle"
                      variant="success"
                      scale="2"
                    ></b-icon>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </b-form>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import postalCodeValidation from "@/mixins/validations/postalCode";
import { required } from "vuelidate/lib/validators";
import { heightTransition } from "@/mixins/ui/transition";
import dateFormat from "@/mixins/dateFormat";
import moment from "jalali-moment";
import MyCleaveDate from "@/components/wrapper/datePicker/MyCleaveDate.vue";

import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
// import { codeBasic } from "./code";

export default {
  components: {
    MyVSelect,
    MyAbDatePicker,
    BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BModal,
    MyCleaveDate,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      nextTodoId: 2,
      spouseDateOfBirth: [],
      spouseDateOfMarriage: [],
      spouseRemoveConfirmation: false,
      spouseToDelete: "",
      // spouseDateOfBirthNotValid: false,
      // dateOfMarriageNotValid: false

      // isSpouseForeigner: [],
    };
  },
  mixins: [postalCodeValidation, heightTransition, dateFormat],
  computed: {
    ...mapGetters({
      countries: "location/countries",
      cities: "cities/cities",
      types: "user/addressTypes",
      spouses: "user/spouses",
      maritalStatus: "user/maritalStatus",
      userToEdit: "user/userToEdit",
      country: "user/country",
      educationalDegreeTypes: "user/educationalDegreeTypes",
    }),
    spouses: {
      get() {
        return this.$store.getters["user/spouses"];
      },
      set(spouses) {
        this.$store.commit("user/SET_SPOUSES_TO_DELETE", spouses);
      },
    },
    spousesToDelete: {
      get() {
        return this.$store.getters["user/spousesToDelete"];
      },
      set() {},
    },
    // persianToday() {
    //   return moment.from(new Date()).locale("fa").format("YYYY/MM/DD");
    // },
    // gregToday() {
    //   return moment.from(new Date()).locale("en").format("YYYY MM  DD, hh:mm:ss");
    // },
  },
  mounted() {
    this.initTrHeight();
    if (this.spouses.length) {
    }
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.spouses.forEach((s, index) => {
      // s.spouseId.dateOfBirth ? s.spouseId.dateOfBirth = this.toUTC(s.spouseId.dateOfBirth) : s.spouseId.dateOfBirth = this.gregToday;
      // this.spouseCountrySelected(index);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  props: ["v", "isMarried", "isSpouseForeigner"],
  methods: {
    searchNationalCode(val) {
      if (val.length === 10) {
        // let this = this;
        this.$store
          .dispatch("user/searchUsers", { nationalCode: val })
          .then((spouses) => {
            spouses.forEach((spouse, index) => {
              this.$set(this.spouses, index, {});
              this.$set(this.spouses[index], "spouseId", {});
              spouse.firstName
                ? this.$set(
                    this.spouses[index].spouseId,
                    "firstName",
                    spouse.firstName
                  )
                : "";
              spouse.lastName
                ? this.$set(
                    this.spouses[index].spouseId,
                    "lastName",
                    spouse.lastName
                  )
                : "";
              // this.userToEdit.dateOfBirth = this.toCleaveDateConvert( this.userToEdit.dateOfBirth, this.isForeigner)
              spouse.dateOfBirth
                ? this.$set(
                    this.spouses[index].spouseId,
                    "dateOfBirth",
                      this.toCleaveDateConvert( spouse.dateOfBirth, this.isSpouseForeigner[index])

                  )
                : "";
              spouse.nationalCode
                ? this.$set(
                    this.spouses[index].spouseId,
                    "nationalCode",
                    spouse.nationalCode
                  )
                : "";
              spouse.countryId
                ? this.$set(
                    this.spouses[index].spouseId,
                    "countryId",
                    spouse.countryId._id
                  )
                : "";
              spouse.educationalDegree
                ? this.$set(
                    this.spouses[index].spouseId,
                    "educationalDegree",
                    spouse.educationalDegree
                  )
                : "";
              this.$set(this.spouses[index], "relationshipId", {});

              this.$set(
                this.spouses[index].relationshipId,
                "dateOfMarriage",
                ""
              );
            });
          });
      }
    },
    spouseCountrySelected(index) {
      let selected = this.countries.find((c) => {
        return c._id == this.spouses[index].spouseId.countryId;
      });
      if (selected) {
        if (selected["alpha_2"] == "IR") {
          this.$set(this.isSpouseForeigner, index, false);
          this.spouses[index].spouseId.identityCode = "";
        } else {
          this.$set(this.isSpouseForeigner, index, true);
          this.spouses[index].spouseId.nationalCode = "";
        }
      }
      // else {
      //   this.spouses[index].spouseId.countryId = this.country;
      // }
      this.$set(this.spouses[index].spouseId, 'dateOfBirth', '')
      this.$set(this.spouses[index].relationshipId, 'dateOfMarriage', '')
      this.v.$reset()
      // this.v.$touch();
    },
    spouseDeletionConfirmed() {
      let index = _.findIndex(
        this.spouses,
        this.spouses.find(
          (s) => s.spouseId._id === this.spouseToDelete.spouseId._id
        )
      );
      if (this.spouses[index].spouseId.id)
        this.spousesToDelete.push(this.spouses[index]);
      this.spouses.splice(index, 1);
      if (index === 0) {
        this.spouses[index] = {
          relationshipId: {
            _id: null,
            dateOfMarriage: "",
          },
          spouseId: {
            // relationshipId: null,
            _id: null,
            countryId: "",
            firstName: "",
            lastName: "",
            fatherName: "",
            nationalCode: "",
            identityCode: "",
            dateOfBirth: "",
          },
          isDeleted: false,
        };
      }
      // this.v.spouses.$reset();
      //   this.spouses.filter(s => {
      //   return s.relationshipId._id === this.spouseToDelete.relationshipId._id
      // })[0].relationshipId._id = null;
    },
    invalidFeedbackSpouseNationalCode(index) {
      var error = "";
      if (!this.v.spouses.$each.$iter[index].spouseId.nationalCode.$dirty)
        return error;
      if (
        !this.v.spouses.$each.$iter[index].spouseId.nationalCode
          .nationalCodeValidation
      )
        error = "invalid";

      if (
        !this.v.spouses.$each.$iter[index].spouseId.nationalCode.multiRequired
      )
        error = "required";
      // if (!this.$v.spouseNationalCode.required) error = "required";
      return error;
    },
    invalidFeedbackSpouseFirstName(index) {
      var error = "";
      if (!this.v.spouses.$each.$iter[index].spouseId.firstName.$dirty)
        return error;
      if (!this.v.spouses.$each.$iter[index].spouseId.firstName.multiRequired)
        error = "required";
      return error;
    },
    invalidFeedbackSpouseLastName(index) {
      var error = "";
      if (!this.v.spouses.$each.$iter[index].spouseId.lastName.$dirty)
        return error;
      if (!this.v.spouses.$each.$iter[index].spouseId.lastName.multiRequired)
        error = "required";
      return error;
    },
    invalidFeedbackSpouseDateOfBirth(index) {
      var error = "";
      if (!this.v.spouses.$each.$iter[index].spouseId.dateOfBirth.$dirty)
        return error;
      if (!this.v.spouses.$each.$iter[index].spouseId.dateOfBirth.multiRequired)
        error = "required";
      if (!this.v.spouses.$each.$iter[index].spouseId.dateOfBirth.dateFormat)
        error = "invalid";
      return error;
    },
    invalidFeedbackSpouseDateOfMarriage(index) {
      var error = "";
      if (
        !this.v.spouses.$each.$iter[index].relationshipId.dateOfMarriage.$dirty
      )
        return error;
      if (
        !this.v.spouses.$each.$iter[index].relationshipId.dateOfMarriage
          .multiRequired
      )
        error = "required";
      if (
        !this.v.spouses.$each.$iter[index].relationshipId.dateOfMarriage
          .dateFormat
      )
        error = "invalid";
      return error;
    },
    invalidFeedbackSpouseDateOfCountry(index) {
      var error = "";
      if (!this.v.spouses.$each.$iter[index].spouseId.countryId.$dirty)
        return error;
      if (!this.v.spouses.$each.$iter[index].spouseId.countryId.multiRequired)
        error = "required";
      return error;
    },
    invalidFeedbackSpouseFatherName(index) {
      var error = "";
      if (!this.v.spouses.$each.$iter[index].spouseId.fatherName.$dirty)
        return error;
      if (!this.v.spouses.$each.$iter[index].spouseId.fatherName.multiRequired)
        error = "required";
      return error;
    },
    // invalidFeedbackSpousCountryId(index) {
    //   var error = "";
    //   if (!this.v.spouses.$each.$iter[index].spouseId.countryId.$dirty)
    //     return error;
    //   if (!this.v.spouses.$each.$iter[index].spouseId.countryId.required)
    //     error = "required";
    //   return error;
    // },

    repeateAgain() {
      this.spouses.push({
        relationshipId: {
          _id: null,
          dateOfMarriage: "",
        },
        spouseId: {
          // relationshipId: null,
          _id: null,
          countryId: "",
          firstName: "",
          lastName: "",
          fatherName: "",
          nationalCode: "",
          identityCode: "",
          dateOfBirth: "",
        },
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.spouseRow[0].offsetHeight);
      });
    },
    removeItem(index) {
      // if (index !== 0) {
      //   this.spouses.splice(index, 1);
      //   this.trTrimHeight(this.$refs.spouseRow[0].offsetHeight);
      // }else{
      if (
        this.spouses[index].spouseId._id &&
        this.spouses[index].relationshipId._id &&
        this.$route.name === "editPatient"
      ) {
        this.spouseRemoveConfirmation = true;
        this.spouseToDelete = this.spouses[index];
        // }
      } else {
        this.spouses.splice(index, 1);
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.spouseForm.scrollHeight);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}
</style>
